import { Location } from 'history';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { AccessToken } from '~/AccessToken';
import { Query } from '~/Api/Product';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import FilterParameter from '~/utils/FilterParameter/FilterParameter';
import { redirectToSearch } from '~/Product';
import { redirectToGroup } from '~/ProductGroup';
import { ApplicationState, ThunkDispatch } from '~/Store';

import ListPage, { Access } from './ListPage';

import type { ProductFilterFormFilters } from '~/ProductFilterForm/ProductFilterForm';

const createDefaultFilterParameters = memoizeOne((selectedTypes: Set<string> | null): ProductFilterFormFilters => {
	return (selectedTypes !== null
		? [new FilterParameter('datasource', Array.from(selectedTypes))]
		: []) as unknown as ProductFilterFormFilters;
});

const selectAccess = memoizeOne((accessToken: AccessToken | null): Access | null => {
	if (!accessToken || !accessToken.subscription) {
		return null;
	}

	const { systemModules } = accessToken.subscription;
	return {
		analytics: systemModules.has('analytics'),
		search: systemModules.has('search-app'),
		productGroups: systemModules.has('product-groups'),
	};
});

function mapStateToProps(
	state: ApplicationState,
	props: {
		// type Location TODO: resolve after bumping react-router-dom
		location: any;
	}
) {
	return {
		access: selectAccess(state.accessToken.accessToken),
		scrollOnList: props.location.hash === '#product-list',
		defaultFilterParameters: createDefaultFilterParameters(state.productSearchableDataSource.selectedTypes),
	};
}

function mapDispatchToProps(dispatch: ThunkDispatch<AnyAction>) {
	return {
		onSearch: (filterParameters: FilterParameter<string | string[]>[]) =>
			dispatch(redirectToSearch(new Query(filterParameters))),
		onGroupCreated: (group: UserProductGroup) => dispatch(redirectToGroup(group)),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ListPage);
